import { request } from '@/plugins/axios'

// page_size	否	int	每页显示条数。不传默认10条
// city	        否	int	城市
// search	    否	string	关键字查询
// start_time	否	array	按起始时间查询

export async function getCustomerList({
    page_size,
    city,
    search,
    start_time
} = {}) {
    return await request({
        url: 'api/a_c/customerList',
        method: 'post',
        data: {
            page_size,
            city,
            search,
            start_time
        }
    })
}
// 退出
export async function logout(params) {
    return await request({
        url: '/api/u_l/logout',
        method: 'post',
        data:params
    })
}

// 上下班状态
export async function switch_set(params) {
    return await request({
        url: '/api/h_i/switch_set',
        method: 'post',
        data:params
    })
}
